import React from 'react'

import { AWSRoleCreationMethod } from 'components/status-checks/authentication-form-utils'
import { AWSCloudFormationRoleAuthentication } from 'components/status-checks/form/authentication/aws/AWSCloudFormationRoleAuthentication'
import { AWSManualRoleAuthentication } from 'components/status-checks/form/authentication/aws/AWSManualRoleAuthentication'

export const AWSIAMRoleSelect: React.FC<{
  awsRoleCreationMethod: AWSRoleCreationMethod
}> = ({ awsRoleCreationMethod }) => {
  switch (awsRoleCreationMethod) {
    case AWSRoleCreationMethod.CloudFormation:
      return <AWSCloudFormationRoleAuthentication />
    default:
      return <AWSManualRoleAuthentication />
  }
}
